"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledButton = exports.StyledUploadBoxContainer = void 0;
const ui_components_1 = require("@groupby/ui-components");
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledUploadBoxContainer = styled_components_1.default.div `
  display: flex;
  align-items: center;
  padding: ${({ theme }) => theme.spacing(0, 3)};
  gap: ${({ theme }) => theme.spacing(2)};

  svg {
    width: unset;
    height: unset;
    fill: none;
  }

  .upload-button-container {
    display: flex;
    flex: 0 1 auto;
    gap: ${({ theme }) => theme.spacing(1)};
    align-items: center;
    flex-direction: row;
  }

  .upload-button-label {
    flex: 0 0 auto;
  }

  .file-upload-input {
    display: none;
  }
`;
exports.StyledButton = (0, styled_components_1.default)(ui_components_1.Button) `
  pointer-events: none;
`;
